export default __webpack_public_path__ + "static/media/i-borghi-piu-belli-italia.0e781b35.svg";